import React, { useState } from "react";
import { faPlus, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getFilteredFunctionList, transformationFunctions } from "../../utils";
import { get, isNull } from "lodash";
import AddToolTip from "../AddToolTip";
import FunctionListSlider from "../../containers/Mapper/MapAndTransformOutput/FunctionListSlider";
import SliderPanel from "../SliderPanel";
import functionList from "./../../containers/Payroll/MapandTransformContainer/FunctionList";

const TransformationFunctionCard = (props) => {
  const {
    index,
    fieldName,
    objName,
    isAdded,
    onDeleteClick,
    setFieldValue,
    values,
    headerError,
    valueError,
    functionList,
  } = props;

  const [openSlider, setOpenSlider] = useState(false);
  const [sliderSize, setSliderSize] = useState(false);
  const data = isNull(index)
    ? get(values, `${objName}.value`, null)
    : get(values, `${fieldName}.value`, []);

  return (
    <div>
      <div className="d-flex justify-content-space-between align-items-center function-card">
        <span
          className="ft-12 ml-3 fw-500 cursor-pointer"
          onClick={() => {
            setSliderSize(false);
            setOpenSlider(!openSlider);
          }}
        >
          {isNull(data) ? (
            <span className="link-text-mapper fw-400">
              Click to add function
            </span>
          ) : (
            <div
              className="d-flex align-items-center"
              style={{ width: "150px" }}
            >
              <AddToolTip name={data?.name} />
              <AddToolTip
                name={transformationFunctions.map((currElement, index) => {
                  if (currElement.id == data?.id) {
                    return currElement.informationDescription;
                  }
                })}
              >
                <i class="fal fa-info-circle retirement-icon ml-1" />
              </AddToolTip>
            </div>
          )}
        </span>
        <div>
          {data?.hasDynamicParameters && (
            <FontAwesomeIcon
              color="#307BF6"
              className="ft-16 func-border-right mr-2 mt-1 cursor-pointer"
              icon={faPlus}
              onClick={() => {
                isNull(index)
                  ? setFieldValue(`${objName}.value`, {
                      ...data,
                      numberOfParameters: data.numberOfParameters + 1,
                      parameters: [
                        ...data?.parameters,
                        {
                          parameterType: 3,
                          value: null,
                          dataType: 1,
                          isAdded: true,
                          headerName: "Field",
                        },
                      ],
                    })
                  : setFieldValue(`${fieldName}.value`, {
                      ...data,
                      numberOfParameters: data.numberOfParameters + 1,
                      parameters: [
                        ...data?.parameters,
                        {
                          parameterType: 3,
                          value: null,
                          dataType: 1,
                          isAdded: true,
                          headerName: "Fields",
                        },
                      ],
                    });
              }}
            />
          )}
          {data && (
            <FontAwesomeIcon
              color="#F16973"
              className="ft-16 mr-1 cursor-pointer"
              icon={faTrashAlt}
              onClick={() => {
                isNull(index)
                  ? setFieldValue(`${objName}.value`, null)
                  : setFieldValue(`${fieldName}.value`, null);
              }}
            />
          )}
          {isAdded && !data && (
            <FontAwesomeIcon
              color="#F16973"
              className="ft-16 mr-1 cursor-pointer"
              icon={faTrashAlt}
              onClick={() => onDeleteClick()}
            />
          )}
        </div>
      </div>
      {(headerError || valueError) && isNull(data) && (
        <div className="ft-12 error-text" style={{ lineHeight: "1rem" }}>
          Required
        </div>
      )}
      <SliderPanel
        isOpen={openSlider}
        size={!sliderSize ? "30" : "80"}
        showCancel={sliderSize ? false : true}
        isMapper={true}
        onClose={() => setOpenSlider(!openSlider)}
      >
        <FunctionListSlider
          functionList={functionList}
          fieldName={fieldName}
          index={index}
          data={data}
          objName={objName}
          sliderSize={sliderSize}
          setSliderSize={setSliderSize}
          setOpenSlider={setOpenSlider}
        />
      </SliderPanel>
    </div>
  );
};

export default TransformationFunctionCard;
